import { BrandSelect, Col, Form, FormModal, Row, Select, Typography } from 'components';
import React from 'react';
import { useAddSubstituteModal } from './useAddSubstituteModal';
import { SubstituteIconBig } from 'components/common/icons';
import { ValidationErrors } from 'constants/validations';

const { Text, Title } = Typography;

export interface IAddSubstituteModal {
  onCancel: () => void;
  open: boolean;
  originalItemId?: string;
}

export const AddSubstituteModal = React.memo((props: IAddSubstituteModal) => {
  const { onCancel, open, originalItemId } = props;
  const { form, onFinish, isLoading, onBrandChange, onItemChange, data, onModalCancel } = useAddSubstituteModal({
    originalItemId,
    onCancel,
  });
  return (
    <FormModal
      form={form}
      okText={'Generate'}
      width={360}
      open={open}
      isLoading={isLoading}
      onCancel={onModalCancel}
      onSubmit={onFinish}
    >
      <Row className={'margin-t-20'}>
        <Col span={24}>
          <Row gutter={[0, 12]} align={'middle'} justify={'center'}>
            <Col>
              <SubstituteIconBig />
            </Col>
            <Col span={24}>
              <Title level={4} className={'reset-title center'}>
                Generate Substitute
              </Title>
            </Col>
            <Col span={24} className={'center'}>
              <Text type={'secondary'} className={'center'}>
                Are you sure you want to generate Substitute item table?
              </Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                label={'Brand*'}
                name={'brandId'}
                rules={[{ required: true, message: ValidationErrors.required('Brand') }]}
              >
                <BrandSelect size={'large'} onChange={onBrandChange} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label={'New Item Code*'}
                name={'sku'}
                rules={[{ required: true, message: ValidationErrors.required('New Item Code') }]}
              >
                <Select
                  size={'large'}
                  options={data}
                  onChange={(_value, option) => onItemChange(option)}
                  disabled={!data?.length}
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    </FormModal>
  );
});
